import { SELECT_LANGUAGE, SET_LANGUAGES, SET_LANGUAGE_ISO, RESET_APP } from '../../constants/action_types';
import { DEFAULT_LANG } from '../../constants/globals';

const defaultState = {
  languageISO: DEFAULT_LANG,
  selectedLanguage: null,
  languages: [],
};

const languagesReducer = (state = defaultState, action) => {
  let selectedLanguage = null;

  switch (action.type) {
    case RESET_APP:
      return { ...defaultState };

    case SET_LANGUAGES:
      return {
        ...state,
        isLoading: false,
        error: '',
        languages: action.languages,
      };

    case SET_LANGUAGE_ISO:
      return {
        ...state,
        languageISO: action.languageISO,
      };

    case SELECT_LANGUAGE:
      selectedLanguage = state.languages.find((language) => language.langISOCode === action.languageISO);

      return {
        ...state,
        selectedLanguage,
      };
    default:
      return state;
  }
};

export default languagesReducer;
